export default function StateBlock({ type = 'empty', title, message, action }) {
  const defaults = {
    loading: { title: 'Loading…', message: '' },
    empty: { title: 'No records found', message: 'Clear filters or add a new record to get started.' },
    error: { title: 'Something went wrong', message: 'Please try again, or contact support if this continues.' },
    noResults: { title: 'No matches', message: 'Try adjusting your search or filters.' },
  };
  const d = defaults[type] || defaults.empty;

  return (
    <div className="state-block">
      <div className="state-block-title">{title || d.title}</div>
      <div>{message || d.message}</div>
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
}
